import request from '@/utils/request'

// 查询银河打本元宝充值配置分页
export function pageIngotConfig(query) {
  return request({
    url: '/played/ingot/config/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本元宝充值配置列表
export function listIngotConfig(query) {
  return request({
    url: '/played/ingot/config/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本元宝充值配置详细
export function getIngotConfig(id) {
  return request({
    url: '/played/ingot/config/' + id,
    method: 'get'
  })
}

// 新增银河打本元宝充值配置
export function addIngotConfig(data) {
  return request({
    url: '/played/ingot/config',
    method: 'post',
    data: data
  })
}

// 修改银河打本元宝充值配置
export function updateIngotConfig(data) {
  return request({
    url: '/played/ingot/config',
    method: 'put',
    data: data
  })
}

// 删除银河打本元宝充值配置
export function delIngotConfig(id) {
  return request({
    url: '/played/ingot/config/' + id,
    method: 'delete'
  })
}
